@if (conditionForm) {
  <form [formGroup]="conditionForm" class="grid grid-cols-3 gap-3">
    <em-select-operand
      [availableAttributes]="availableAttributes"
      [customAttributes]="customAttributes"
      formControlName="leftOperand"
    >
    </em-select-operand>
    <em-select
      formControlName="operator"
      [subscriptSizing]="'dynamic'"
      [label]="'SHARED_LABEL_SELECT_OPERATOR' | translate"
    >
      @if (operatorControl?.value) {
        <ng-container emPrefix>
          <mat-icon class="text-primary-300">{{
            getOperatorIcon(operatorControl?.value)
          }}</mat-icon></ng-container
        >
      }
      <ng-container emSelectTrigger>{{
        'OPERATOR_' + operatorControl?.value?.toUpperCase() | translate
      }}</ng-container>
      @for (group of operatorGroups; track group) {
        <em-option-group
          [label]="'OPERATOR_GROUP_' + group.name.toUpperCase() | translate"
        >
          @for (operator of group.operators; track operator) {
            <em-option [value]="operator.name">
              @if (operator.name) {
                <mat-icon class="text-primary-300">{{
                  getOperatorIcon(operator.name)
                }}</mat-icon>
              }
              {{ 'OPERATOR_' + operator.name.toUpperCase() | translate }}
            </em-option>
          }
        </em-option-group>
      }
      <em-error>
        {{ 'SHARED_REQUIRED_FIELD' | translate }}
      </em-error>
    </em-select>
    @if (requireRightOperand) {
      <em-select-operand
        [availableAttributes]="availableAttributes"
        [customAttributes]="customAttributes"
        [allowStaticValues]="true"
        [type]="operatorType === 'date' ? operatorType : 'string'"
        formControlName="rightOperand"
      >
      </em-select-operand>
    }
  </form>
}
